var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotepad = function SvgIconNotepad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.625a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM9 14.375a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.875 2.25a1 1 0 0 0-2 0v.5H5.25A1.75 1.75 0 0 0 3.5 4.5v14.25A3.25 3.25 0 0 0 6.75 22h10.5a3.25 3.25 0 0 0 3.25-3.25V4.5a1.75 1.75 0 0 0-1.75-1.75h-1.625v-.5a1 1 0 1 0-2 0v.5H13v-.5a1 1 0 1 0-2 0v.5H8.875zm6.25 2.5H13v.5a1 1 0 1 1-2 0v-.5H8.875v.5a1 1 0 0 1-2 0v-.5H5.5v14A1.25 1.25 0 0 0 6.75 20h10.5a1.25 1.25 0 0 0 1.25-1.25v-14h-1.375v.5a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconNotepad;